import { getDeployEnv } from '@ecomm/data-env-variables/deployEnv'
import type { ReactElement, ReactNode } from 'react'
import React, { Children } from 'react'

const getTestModeValue = (env = 'qa') => (env === 'prd' ? 'false' : 'true')

// Checks if a React element is a custom component (function or web component).
const isCustomComponent = (child: ReactElement) =>
  typeof child.type === 'function' ||
  (typeof child.type === 'string' && child.type.includes('-'))

/**
 * Clones a React element and adds AI props if it's a custom component.
 * @returns The original child or a cloned element with AI props
 */
const cloneElementWithAIProps = (child: ReactNode) => {
  if (!React.isValidElement(child) || !isCustomComponent(child)) {
    return child
  }

  const additionalProps = {
    testMode: getTestModeValue(getDeployEnv())
  }

  return React.cloneElement(child, additionalProps)
}

/**
 * Processes React children and adds AI web component props to custom components only.
 * leaving DOM elements unchanged to prevent React warnings.
 *
 * @returns The processed children with AI props added
 */
export const renderClonedChildrenWithAIProps = (children: ReactNode) =>
  Children.map(children, child => cloneElementWithAIProps(child))
